import { getAppropriateRiskLimiter } from './';

export function formatRiskRound(impact: number | string | undefined, cancerType?: string): string {
  const limiter = getAppropriateRiskLimiter(cancerType);
  const limitedImpact = limiter(impact);

  if (typeof limitedImpact === 'number') return `${Math.round(limitedImpact)}%`;
  if (typeof limitedImpact === 'string') {
    if (!isNaN(Number(limitedImpact))) return `${Math.round(Number(limitedImpact))}%`;
    return limitedImpact;
  }
  return 'N/A';
}
